import { render, staticRenderFns } from "./facturascv.vue?vue&type=template&id=38b5a0e1&scoped=true"
import script from "./facturascv.vue?vue&type=script&lang=js"
export * from "./facturascv.vue?vue&type=script&lang=js"
import style0 from "./facturascv.vue?vue&type=style&index=0&id=38b5a0e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b5a0e1",
  null
  
)

export default component.exports